import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MatDialog, MatSidenav } from '@angular/material';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { SignaturePadComponent } from 'src/app/commons/signature-pad/signature-pad.component';
import { NewFileModalComponent } from 'src/app/files/new-file-modal/new-file-modal.component';
import { AssetService } from 'src/app/services/asset.service';
import { UserDocumentService } from 'src/app/services/user-document.service';
import { UtilityService } from 'src/app/services/utility.service';
import * as _ from 'lodash';
import * as moment from 'moment';

@Component({
  selector: 'app-vehicle-inspection-checklist',
  templateUrl: './vehicle-inspection-checklist.component.html',
  styleUrls: ['./vehicle-inspection-checklist.component.scss']
})
export class VehicleInspectionChecklistComponent implements OnInit {

  vehicleInspectionForm: FormGroup
  sign: Boolean = false
  assetId
  userId: any;
  loading
  vehicleInspectionFormData = []
  selectedIndex
  selectedFormDetails
  isEdit: Boolean
  files: any = [];
  newFiles: any = [];
  @Output() getFileDetails: EventEmitter<any> = new EventEmitter<any>();
  @Output() openFilesSideNav: EventEmitter<any> = new EventEmitter();
  @ViewChild('sidenav', { static: false }) public mydsidenav: MatSidenav;
  previousIndex: any;
  isSubmit: boolean;
  @Input('asset') assetData
  @Input('user') userData
  @Input('documentData') documentDetails
  currentUser: any;
  _driverName: string;
  _vehicleReg: string
  _isControlDisable = false

  constructor(
    public dialog: MatDialog,
    public router: Router,
    public activatedRouter: ActivatedRoute,
    public _assetService: AssetService,
    public _utilityService: UtilityService,
    public _userDocumentService: UserDocumentService,
  ) { }

  ngOnInit() {
    this.activatedRouter.params.subscribe(params => {
      // this.dataSource = new MatTableDataSource(this.userList);
      this.assetId = params.id;

      // this.getSingleAseetDetails()
    })
    this.activatedRouter.queryParams.subscribe(params => {
      if (params && params._userDVN) {
        console.log('check params data..', params, this.assetId)
        this._driverName = params._userDVN
      }
      if (params && params._regNum) {
        console.log('check params data..', params, this.assetId)

        this._vehicleReg = params._regNum
      }
    })
    this.currentUser = JSON.parse(localStorage.getItem('currentUser'))
    console.log("this.currentUser", this.currentUser);
    this.createForm();
    this.isSubmit = false;
  }

  ngOnChanges(changes: SimpleChanges): void {
    console.log("Vehicle changes", changes);
    if (changes.assetData && changes.assetData.currentValue) {
      this.assetData = changes.assetData.currentValue
      console.log("this.assetData", this.assetData);
    }

    if (changes.userData && changes.userData.currentValue) {
      this.userId = changes.userData.currentValue
      console.log("this.userData", this.userData);
    }

    if (changes.documentDetails && changes.documentDetails.currentValue) {

      let data = changes.documentDetails.currentValue
      console.log("data--->", data);
      // this.vehicleInspectionFormData = data
      // console.log("tempData[i].documentMetaId", data[0].userDocumentId.documentMetaId);


      let allFormList = data.filter((x) => x.userDocumentId.documentMetaId.title === 'vehicleInspectionForm')
      console.log("same for data for multiple forms", allFormList);

      if (allFormList && allFormList.length) {
        this.vehicleInspectionFormData = allFormList
        this.selectedIndex = this.vehicleInspectionFormData[0]._id
        this.selectedFormDetails = this.vehicleInspectionFormData[0].userDocumentId
        this._isControlDisable = true
        // this.createForm(this.vehicleInspectionFormData[0].userDocumentId.details.inspectionForm)
        this.changeFormData()
      }
    }
  }


  createForm(data?) {
    console.log("VALUE OF VEHILE INSPECTION FORM", data);
    this.vehicleInspectionForm = new FormGroup({
      driverName: new FormControl((data && data.driverName) ? data.driverName : this._driverName),
      regNo: new FormControl((data && data.regNo) ? data.regNo : this._vehicleReg),
      inspectionDate: new FormControl((data && data.inspectionDate) ? data.inspectionDate : moment(new Date()).format("MM/DD/YYYY")),
      actionRequire: new FormControl((data && data.actionRequire) ? data.actionRequire : ''),
      actionComplete: new FormControl((data && data.actionComplete) ? data.actionComplete : ''),
      repairDate: new FormControl((data && data.repairDate) ? data.repairDate : ''),
      actionBy: new FormControl((data && data.actionBy) ? data.actionBy : ''),
      mileage: new FormControl((data && data.mileage) ? data.mileage : ''),
      suff_insuff1: new FormControl((data && data.suff_insuff1) ? data.suff_insuff1 : ''),
      suff_insuff2: new FormControl((data && data.suff_insuff2) ? data.suff_insuff2 : ''),
      suff_insuff3: new FormControl((data && data.suff_insuff3) ? data.suff_insuff3 : ''),
      suff_insuff4: new FormControl((data && data.suff_insuff4) ? data.suff_insuff4 : ''),
      suff_insuff5: new FormControl((data && data.suff_insuff5) ? data.suff_insuff5 : ''),
      suff_insuff6: new FormControl((data && data.suff_insuff6) ? data.suff_insuff6 : ''),
      suff_insuff7: new FormControl((data && data.suff_insuff7) ? data.suff_insuff7 : ''),
      suff_insuff8: new FormControl((data && data.suff_insuff8) ? data.suff_insuff8 : ''),
      suff_insuff9: new FormControl((data && data.suff_insuff9) ? data.suff_insuff9 : ''),
      suff_insuff10: new FormControl((data && data.suff_insuff10) ? data.suff_insuff10 : ''),
      suff_insuff11: new FormControl((data && data.suff_insuff11) ? data.suff_insuff11 : ''),
      suff_insuff12: new FormControl((data && data.suff_insuff12) ? data.suff_insuff12 : ''),
      suff_insuff13: new FormControl((data && data.suff_insuff13) ? data.suff_insuff13 : ''),
      suff_insuff14: new FormControl((data && data.suff_insuff14) ? data.suff_insuff14 : ''),
      suff_insuff15: new FormControl((data && data.suff_insuff15) ? data.suff_insuff15 : ''),
      suff_insuff16: new FormControl((data && data.suff_insuff16) ? data.suff_insuff16 : ''),
      suff_insuff17: new FormControl((data && data.suff_insuff17) ? data.suff_insuff17 : ''),
      suff_insuff18: new FormControl((data && data.suff_insuff18) ? data.suff_insuff18 : ''),
      suff_insuff19: new FormControl((data && data.suff_insuff19) ? data.suff_insuff19 : ''),
      suff_insuff20: new FormControl((data && data.suff_insuff20) ? data.suff_insuff20 : ''),
      comment1: new FormControl((data && data.comment1) ? data.comment1 : ''),
      comment2: new FormControl((data && data.comment2) ? data.comment2 : ''),
      comment3: new FormControl((data && data.comment3) ? data.comment3 : ''),
      comment4: new FormControl((data && data.comment4) ? data.comment4 : ''),
      comment5: new FormControl((data && data.comment5) ? data.comment5 : ''),
      comment6: new FormControl((data && data.comment6) ? data.comment6 : ''),
      comment7: new FormControl((data && data.comment7) ? data.comment7 : ''),
      comment8: new FormControl((data && data.comment8) ? data.comment8 : ''),
      comment9: new FormControl((data && data.comment9) ? data.comment9 : ''),
      comment10: new FormControl((data && data.comment10) ? data.comment10 : ''),
      comment11: new FormControl((data && data.comment11) ? data.comment11 : ''),
      comment12: new FormControl((data && data.comment12) ? data.comment12 : ''),
      comment13: new FormControl((data && data.comment13) ? data.comment13 : ''),
      comment14: new FormControl((data && data.comment14) ? data.comment14 : ''),
      comment15: new FormControl((data && data.comment15) ? data.comment15 : ''),
      comment16: new FormControl((data && data.comment16) ? data.comment16 : ''),
      comment17: new FormControl((data && data.comment17) ? data.comment17 : ''),
      comment18: new FormControl((data && data.comment18) ? data.comment18 : ''),
      comment19: new FormControl((data && data.comment19) ? data.comment19 : ''),
      comment20: new FormControl((data && data.comment20) ? data.comment20 : ''),
      sign: new FormControl((data && data.sign) ? data.sign : ''),
    })
    console.log("VEHICLE FORM", this.vehicleInspectionForm)
    if (this._isControlDisable) {
      this.vehicleInspectionForm.disable()
    }
  }

  onChangeEvent(value, formGroup, formControl) {
    console.log("value, formControl, formGroup", value, formControl, formGroup);

    if (formGroup == 'vehicleInspectionForm')
      this.vehicleInspectionForm.get(formControl).setValue(value);
  }

  addNewForm() {
    this._assetService.closeDisplayFile(true)
    let obj = {
      _id: 'new',
      submissionDate: new Date(),
      userDocumentId: {}
    }
    let details = {}
    details['vehicleInspectionForm'] = {}
    obj.userDocumentId['details'] = details
    this.vehicleInspectionFormData.push(obj)
    this.selectedIndex = this.vehicleInspectionFormData[this.vehicleInspectionFormData.length - 1]._id
    this.selectedFormDetails = this.vehicleInspectionFormData[this.vehicleInspectionFormData.length - 1].userDocumentId
    this._isControlDisable = false
    this.createForm({})
    this.isEdit = false
    this.sign = false
    this.files = []
  }


  changeEvent(event, id, index) {
    console.log("event", event);
    console.log("id", id);
    console.log("vehicleInspectionFormData", this.vehicleInspectionFormData);
    console.log("index", index);
    this.selectedIndex = this.vehicleInspectionFormData[index]._id
    this.selectedFormDetails = this.vehicleInspectionFormData[index].userDocumentId
    if (this.selectedIndex !== 'new') {
      this._isControlDisable = true
    } else {
      this._isControlDisable = false
    }
    this.changeFormData()
  }

  addFileModal() {
    let obj = {
      isIncident: true
    }
    this._utilityService.commonDialogBoxOpen(NewFileModalComponent,
      obj, '', '100%', '100vw', '100vh').afterClosed().subscribe((fileQueue) => {
        console.log("The queue recieved is", fileQueue);
        if (fileQueue == undefined || fileQueue.length == 0) return;

        _.forEach(fileQueue, (file) => {
          if (this.isEdit) {
            this.newFiles.push(file)
          } else {
            this.files.push(file);
          }
        })
        this._utilityService.handleSnackBar({ msg: "File uploaded successfully!", button: "OK" })

      }, err => {
        this._utilityService.handleSnackBar({ msg: "Something went wrong!", button: "OK" })
      });
  }

  deleteFile(event, index) {
    console.log("event if file removed", event, index);
    this.files.splice(index, 1)
    console.log("after file removd", this.files);

  }
  deleteNewFile(event, index) {
    this.newFiles.splice(index, 1)
  }

  addSignature(fomrControl) {
    const dialogRef = this._utilityService.commonDialogBoxOpen(SignaturePadComponent,
      null, '100%', '100%', '100vw', '100vh').afterClosed().subscribe((data) => {
        console.log("data of sign", data);
        this.sign = true
        this.isSubmit = false
        if (fomrControl == 'sign') {
          this.vehicleInspectionForm.patchValue({
            sign: data
          })
          console.log("sign value", this.vehicleInspectionForm.value);
        }
      })
  }


  changeFormData() {
    this.isEdit = true
    console.log("this.selectedFormDetails.details.vehicleInspectionForm", this.selectedFormDetails.details.vehicleInspectionForm.sign);
    if (this.selectedFormDetails.details.vehicleInspectionForm.sign) {
      this.sign = true
    }
    else {
      this.sign = false
    }
    this.files = this.selectedFormDetails.files && this.selectedFormDetails.files.length ? this.selectedFormDetails.files : []
    this.createForm(this.selectedFormDetails.details.vehicleInspectionForm)
  }





  onSubmit() {
    console.log("this.vehicleInspectionForm.value", this.vehicleInspectionForm.value)
    this.loading = true
    if (this.vehicleInspectionForm.valid) {
      if (this.isEdit) {
        let obj = {
          metaObj: {
            title: 'vehicleInspectionForm',
          },
          documentId: this.selectedFormDetails.documentId,
          userId: this.userId,
          onModel: 'asset',
          documentMetaId: this.selectedFormDetails.documentMetaId,
          userDocumentId: this.selectedFormDetails._id,
          files: this.files,
          newFiles: this.newFiles,
          details: {}
        }
        let details = {
          vehicleInspectionForm: this.vehicleInspectionForm.value
        }
        obj['details'] = details
        this._userDocumentService.updateUserDocument(obj).subscribe((response) => {
          console.log("response of new user document", response);
          this._utilityService.handleSnackBar({ msg: "Data updated successfully!", button: "OK" })
          this.loading = false
          this.redirect()
        }, error => {
          console.log("error while submit form", error);
          this._utilityService.handleSnackBar({ msg: "Something went wrong!", button: "OK" })
          this.loading = false
        })
      }
      else {
        let obj = {
          metaObj: {
            title: 'vehicleInspectionForm',
          },
          documentId: this.assetId,
          userId: this.userId,
          onModel: 'asset',
          files: this.files,
          // documentId: this.planFormDetails._id,
          details: {}
        }
        let details = {
          vehicleInspectionForm: this.vehicleInspectionForm.value
        }
        obj['details'] = details
        this._assetService.submitAssetForm(obj).subscribe((response) => {
          console.log("response of new user document", response);
          this.loading = false
          this._utilityService.handleSnackBar({ msg: "Data added successfully!", button: "OK" })
          this.redirect()
        }, error => {
          console.log("error while submit form", error);
          this._utilityService.handleSnackBar({ msg: "Something went wrong!", button: "OK" })
          this.loading = false
        })
      }
    }
    else {
      this.isSubmit = true
    }
  }

  redirect() {
    this._assetService.closeDisplayFile(true)
    if (this.currentUser && (this.currentUser.userRole.includes('admin') || this.currentUser.userRole.includes('assetManager'))) {
      console.log("user is admin");
      this.router.navigate(['/asset/single-asset/' + this.assetData])
    }
    else {
      this.router.navigate(['/asset/asset-list/'])
    }
  }

  fileDetails(event) {
    console.log("event ====", event);
    this.previousIndex = event.index
    // this._sidenavService.setSidenav(event)
    this.openFilesSideNav.emit({ event })
  }
}
